export const convertToHtml = (text) => {
  if (!text) return '';
  if (text.includes('<br')) {
    return text;
  }
  // Replace each \n with <br />
  return text.replace(/\n/g, '<br />');
};

/**
 * Read-only rich display (e.g. secure message thread): converts literal newlines to `<br />`.
 * Unlike `convertToHtml`, always runs even when the string already contains `<br>` so
 * mixed bodies (plain text plus review links) still show line breaks.
 *
 * @param {string} [text]
 * @returns {string}
 */
export const newlinesToBrForDisplay = (text) => {
  if (text == null || text === '') return '';
  return String(text).replace(/\r\n|\n|\r/g, '<br />');
};
